import { cloneElement, isValidElement } from 'react'
import { usePage } from '@inertiajs/react'
import { enGB, es, ru } from 'react-day-picker/locale'

const state = { locale: 'en', translations: {} }

export function currentLocale() {
  return state.locale
}

const CALENDAR_LOCALES = { en: enGB, es, ru }

export function calendarLocale() {
  return CALENDAR_LOCALES[state.locale] ?? enGB
}

export function dateLocale() {
  return state.locale === 'en' ? 'en-GB' : state.locale
}

function lookup(key) {
  return key.split('.').reduce((node, part) => (node && typeof node === 'object' ? node[part] : undefined), state.translations)
}

function interpolate(text, values) {
  return text.replace(/%\{(\w+)\}/g, (match, name) => (values[name] === undefined ? match : String(values[name])))
}

// Plural forms follow the language's own rules (Russian has one, few, many and other).
export function translate(key, values = {}) {
  let entry = lookup(key)

  if (entry && typeof entry === 'object' && 'count' in values) {
    const form = new Intl.PluralRules(state.locale).select(values.count)
    entry = entry[form] ?? entry.other
  }

  return typeof entry === 'string' ? interpolate(entry, values) : key
}

// Like translate, but puts React elements (such as links) in place of their %{name} placeholders.
export function translateWithElements(key, elements) {
  return translate(key).split(/(%\{\w+\})/).map((part, index) => {
    const element = elements[part.slice(2, -1)]
    return part.startsWith('%{') && isValidElement(element) ? cloneElement(element, { key: index }) : part
  })
}

export function useT() {
  const { locale, translations } = usePage().props
  if (locale) state.locale = locale
  if (translations) state.translations = translations
  return translate
}
